import { createBrowserRouter } from "react-router-dom";
import Dashboard from "../Pages/Dashboard";
import AdminSectionManager from "../Pages/AdminSectionManager";
import SeoSettings from "../Pages/SeoSettings";
import AdminServicesManager from "../Pages/AdminServicesManager";
import HomePageManager from "../Pages/HomePageManager";
import AboutPageManager from "../Pages/AboutPageManager";
import LocationsManager from "../Pages/LocationsManager";
import ListRequestsPage from "../Pages/ListRequestsPage";
import PrivateRoutes from "./PrivateRoutes";
import Login from "../Pages/Login";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PrivateRoutes>
        <Dashboard />
      </PrivateRoutes>
    ),
    children: [
      {
        path: "/",
        element: (
          <PrivateRoutes>
            <AdminSectionManager />
          </PrivateRoutes>
        ),
      },
      {
        path: "/home-page",
        element: (
          <PrivateRoutes>
            <HomePageManager />
          </PrivateRoutes>
        ),
      },
      {
        path: "/about-page",
        element: (
          <PrivateRoutes>
            <AboutPageManager />
          </PrivateRoutes>
        ),
      },
      {
        path: "/locations",
        element: (
          <PrivateRoutes>
            <LocationsManager />
          </PrivateRoutes>
        ),
      },
      {
        path: "/list-requests",
        element: (
          <PrivateRoutes>
            <ListRequestsPage />
          </PrivateRoutes>
        ),
      },
      {
        path: "/seo-setting",
        element: (
          <PrivateRoutes>
            <SeoSettings />
          </PrivateRoutes>
        ),
      },
      {
        path: "/manage-services",
        element: (
          <PrivateRoutes>
            <AdminServicesManager />
          </PrivateRoutes>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);
